/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react';
import { Container, Row, Col, ListGroup, Button } from 'react-bootstrap';
import { Header, EmpresaModal, StoresModal } from 'components';
import { useSelector } from 'react-redux';
import { format } from 'date-fns';
import logo from 'assets/images/cnncta.png';
import styled from 'styled-components';
import api from 'config/api';
import { filterObj } from 'utils';
import _ from 'lodash';
import { Send } from 'react-feather';

// eslint-disable-next-line import/no-unresolved

const ListaDetalhes = styled(ListGroup)`
  background: transparent;
`;

const ListItem = styled(ListGroup.Item)`
  background: transparent;
  border: none;
  padding: 0;
  p {
    padding: 0;
    margin-bottom: 10px;
  }
`;

const LinkButton = styled.button`
  color: #0b4d83;
  background: transparent;
  border: none;
  padding: 0;
`;

const EmpresaContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
  height: 100px;

  h1 {
    margin: 0;
    margin-left: 15px;
    font-size: 20px;
    font-weight: 400;
  }
`;
const Logo = styled.img`
  width: 100px;
`;

const Box = styled.div`
  padding: 25px 0px;
  h2 {
    font-size: 22px;
    font-weight: 400;
  }
  p {
    color: #707070;
  }
`;

const Separador = styled.div`
  height: 50%;
  width: 1px;
  background: #707070;
`;

const VagaPage = ({ match }) => {
  const [visible, setVisible] = useState(false);
  const [visibleStore, setVisibleStore] = useState(false);

  const constantes = useSelector(state => state.constantes);
  const [vaga, setVaga] = useState({});

  useEffect(() => {
    const fetchVaga = async () => {
      const res = await api.get(`/vagas/publico/${match.params.id}`);
      setVaga(res.data.data.vaga);
    };
    fetchVaga();
  }, []);

  return (
    <>
      {!_.isEmpty(vaga) && (
        <>
          <Header logosOnly height="150px" />
          <EmpresaContainer>
            <Logo src={logo} />
            <h1>{vaga.empresa.nome_fantasia}</h1>
          </EmpresaContainer>
          <EmpresaModal visible={visible} setVisible={setVisible} empresa={vaga.empresa} />
          <StoresModal visible={visibleStore} setVisible={setVisibleStore} />

          <Container className="pt-5">
            <Row>
              <Col md={5}>
                <Box>
                  <h2>{vaga.titulo}</h2>
                  {vaga.descricao}
                </Box>
                <Button variant="success" size="sm" onClick={() => setVisibleStore(true)}>
                  Candidatar-se
                  <Send size={16} style={{ marginLeft: 5 }} />
                </Button>
              </Col>
              <Col md={2} className="d-flex justify-content-center align-items-center">
                <Separador />
              </Col>
              <Col md={5}>
                <Box>
                  <h2>Detalhes da Vaga</h2>
                  <ListaDetalhes>
                    <ListItem>
                      <span>Salário</span>
                      <p>R$ {vaga.salario}</p>
                    </ListItem>
                    <ListItem>
                      <span>Regime de contratação</span>
                      <p>
                        {filterObj(constantes.regime_de_contratacao, vaga.regime_de_contratacao)}
                      </p>
                    </ListItem>
                    <ListItem>
                      <span>Escolaridade</span>
                      <p>
                        {filterObj(constantes.nivel_de_escolaridade, vaga.nivel_de_escolaridade)}
                      </p>
                    </ListItem>
                    <ListItem>
                      <span>Data de publicação</span>
                      <p>{format(new Date(vaga.criado_em), 'dd/MM/yyyy')}</p>
                    </ListItem>
                    <ListItem>
                      <span>Última atualização</span>
                      <p>{format(new Date(vaga.ultima_atualizacao_em), 'dd/MM/yyyy')}</p>
                    </ListItem>
                  </ListaDetalhes>
                  <LinkButton onClick={() => setVisible(true)}>Detalhes da Empresa</LinkButton>
                </Box>
              </Col>
            </Row>
          </Container>
        </>
      )}
    </>
  );
};

export default VagaPage;
